import { render, staticRenderFns } from "./FranqueadorPendente.vue?vue&type=template&id=cb1870ba&scoped=true"
import script from "./FranqueadorPendente.vue?vue&type=script&lang=js"
export * from "./FranqueadorPendente.vue?vue&type=script&lang=js"
import style0 from "./FranqueadorPendente.vue?vue&type=style&index=0&id=cb1870ba&prod&lang=scss&scoped=true"
import style1 from "./FranqueadorPendente.vue?vue&type=style&index=1&id=cb1870ba&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cb1870ba",
  null
  
)

export default component.exports